import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import {
  FolderOpenRounded,
  TrendingDownRounded,
  TrendingUpRounded,
} from "@mui/icons-material";
import Categories from "./Categories/Categories";
import Tags from "./Tags";

const useStyles = makeStyles()((theme) => ({
  container: {
    padding: 16,
    backgroundColor: theme.palette.background.dark,
    borderRadius: 24,
  },
  card: {
    width: "100%",
    padding: 16,
    border: "1px solid #E3F2FD",
    backgroundColor: theme.palette.background.default,
    borderRadius: 12,
    boxShadow: "0 0 12px 1px rgba(191, 191, 191, 0.16)",
  },
}));

function Files({ files }) {
  const {
    total,
    categories,
    tags,
    change: { total_pct, total_direction },
  } = files;
  const { classes } = useStyles();

  return (
    <Box className={classes.container}>
      <Box px={2} mb={1.5}>
        <Typography variant="h6">Files</Typography>
      </Box>

      <Grid container spacing={2} alignItems="stretch">
        <Grid
          item
          size={{ xs: 12, md: 4 }}
          sx={{ display: "flex", flexDirection: "column" }}>
          <Box
            sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <Box className={classes.card}>
              <Box display="flex" alignItems="center" gap={1} mb={1}>
                <Box
                  height={30}
                  width={30}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  sx={{ background: "#E3F2FD", borderRadius: 1 }}>
                  <FolderOpenRounded sx={{ fontSize: 16, color: "#2196F3" }} />
                </Box>
                <Typography variant="body2" color="text.secondary">
                  Total Files
                </Typography>
              </Box>

              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                gap={1}>
                <Typography variant="h4">{total}</Typography>
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-end">
                  <Box display="flex" alignItems="center" gap={0.5}>
                    {total_direction === "increase" ? (
                      <TrendingUpRounded
                        sx={{ fontSize: 16, color: "#1B5E20" }}
                      />
                    ) : (
                      <TrendingDownRounded
                        sx={{ fontSize: 16, color: "#B71C1C" }}
                      />
                    )}
                    <Typography
                      fontSize={13}
                      fontWeight={500}
                      sx={{
                        color:
                          total_direction === "increase"
                            ? "#1B5E20"
                            : "#B71C1C",
                      }}>
                      {Math.round(total_pct)}%
                    </Typography>
                  </Box>
                  <Typography variant="caption" color="text.secondary">
                    WoW
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box mb={2} />
            <Tags tags={tags} />
          </Box>
        </Grid>
        <Grid item size={{ xs: 12, md: 8 }} sx={{ display: "flex" }}>
          <Categories categories={categories} />
        </Grid>
      </Grid>
    </Box>
  );
}

export default Files;
